import React from "react";
import { Link } from "react-router-dom";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/delivery.scss";

function Delivery() {
  const regions = [
    ["United States", "3–5 business days", formatPrice(siteConfig.shipping.standardCost), `Free from ${formatPrice(siteConfig.shipping.freeThreshold)}`],
    ["Canada", "4–7 business days", "$18", "Duties calculated at checkout"],
    ["United Kingdom", "3–5 business days", "$15", "Duties included"],
    ["European Union", "3–6 business days", "$12", "Duties included"],
    ["Rest of world", "5–10 business days", "$25", "Shown at checkout"],
  ];

  return (
    <main className="info-page delivery-page">
      <header className="info-hero"><p className="eyebrow">HELP</p><h1>Shipping</h1><p>From our atelier to your door, with clear timing and thoughtful packaging.</p></header>
      <section className="delivery-table-wrap">
        <div className="delivery-table__head"><span>Destination</span><span>Estimated time</span><span>Standard</span><span>Notes</span></div>
        {regions.map((row) => <div className="delivery-table__row" key={row[0]}>{row.map((cell, index) => <span key={cell} data-label={["Destination", "Time", "Price", "Notes"][index]}>{cell}</span>)}</div>)}
      </section>
      <section className="info-columns">
        <article><span>01</span><h2>Preparing your order</h2><p>Orders are prepared Monday through Friday. You will receive tracking by email as soon as your parcel leaves us.</p></article>
        <article><span>02</span><h2>Duties & taxes</h2><p>All applicable taxes are shown before payment. Where duties are included, there will be no surprise charge at delivery.</p></article>
        <article><span>03</span><h2>Responsible packaging</h2><p>Your order arrives in recycled and recyclable packaging, sized to protect the pieces without unnecessary material.</p></article>
      </section>
      <section className="info-cta"><h2>Still have a question?</h2><p>Our team can help with a destination or an order already on its way.</p><Link className="button button--dark" to="/contact">Contact us</Link></section>
    </main>
  );
}

export default Delivery;
